/**
 * Flush option lists in overlays (dropdown, context menu, select, custom
 * popovers). No list inset, no item radius — hover fills edge to edge; the
 * outer shell (`overflow-hidden rounded-*`) clips corners.
 */

/** Content / list inset. Do not add `py-*` on option stacks. */
export const OVERLAY_OPTION_LIST_INSET_CLASS = "p-0";

/** Vertical option stack — no inter-row gap. */
export const OVERLAY_OPTION_LIST_STACK_CLASS = "flex w-full flex-col";

/**
 * Item shape for hover/focus/selected fills. Square corners so adjacent rows
 * meet with no white pocket. Do not add `rounded-*` on overlay option rows.
 */
export const OVERLAY_OPTION_ITEM_SHAPE_CLASS = "rounded-none";

/**
 * Custom button / option row chrome. Pair with padding + hover classes.
 * Do not add `rounded-*` or list `gap-*` / wrapper `p-*`.
 *
 * Labels stay left-aligned (hard). Never `justify-center`, `text-center`, or
 * `justify-between` on the row — short labels float mid-row between leading
 * mark and trailing check. Use `flex-1 text-left` on the label instead.
 * Gate: `bun run lint:overlay-option-align`.
 */
export const OVERLAY_OPTION_ROW_CLASS =
  "flex w-full min-w-0 items-center rounded-none text-left transition-colors";

/** Full-bleed separator between option groups (no negative margin). */
export const OVERLAY_OPTION_SEPARATOR_CLASS = "my-0 h-px bg-muted";

/** PopoverContent shell for option lists — flush; add `overflow-hidden` to clip. */
export const OVERLAY_OPTION_POPOVER_CONTENT_CLASS = "p-0 shadow-md";

/**
 * Named group on overlay content. First-option arm CSS lives in
 * `globals.css` (first enabled descendant in tree order). Skip that arm with
 * `data-compact-filter-index` or {@link OVERLAY_LIST_KEYBOARD_ATTR}.
 * Gate: `bun run lint:popover-list-search`.
 */
export const OVERLAY_LIST_ROOT_CLASS = "group/popoverlist";

/**
 * Lists that paint their own arrow-key highlight. Put on the option stack so
 * the CSS first-option arm does not sit on a second row.
 */
export const OVERLAY_LIST_KEYBOARD_ATTR = "data-overlay-list-keyboard";

/**
 * First option looks selected while search is focused (Enter confirms it).
 * Skip when the list wires `pickerIndex` / keyboard highlight itself.
 */
export const OVERLAY_LIST_ARMED_FIRST_OPTION_CLASS =
  "group-focus-within/popoverlist:first-of-type:bg-accent/80";
